import { createFileRoute, Navigate } from "@tanstack/react-router";
export const Route = createFileRoute("/_authed/spaces")({ component: () => <Navigate to="/" replace /> });
